// src/pages/ForgotPasswordPage.js

import React, { useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import UrlConfig from '../../data/UrlConfig';

const translations = {
  en: {
    title: 'Recover Password',
    subtitle: 'Enter your email to receive a recovery link.',
    emailLabel: 'Email Address',
    sending: 'Sending...',
    sendLink: 'Send Link',
    successMessage: 'If your email is in our system, you will receive a link to recover your password.',
    rememberedPassword: 'Remembered your password?',
    logIn: 'Log in',
  },
  es: {
    title: 'Recuperar Contraseña',
    subtitle: 'Ingresa tu email para recibir un enlace de recuperación.',
    emailLabel: 'Correo Electrónico',
    sending: 'Enviando...',
    sendLink: 'Enviar Enlace',
    successMessage: 'Si tu correo está en nuestro sistema, recibirás un enlace para recuperar tu contraseña.',
    rememberedPassword: '¿Recordaste tu contraseña?',
    logIn: 'Inicia sesión',
  },
};

const ForgotPasswordPage = () => {
  const { lang } = useParams();
  const t = translations[lang] || translations.es;

  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError('');
    setMessage('');

    try {
      const response = await fetch(UrlConfig.auth_password_request, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, lang }), // Enviamos el idioma
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || 'Error requesting reset.');
      }
      
      // Usamos el mensaje traducido que viene del backend
      setMessage(data.message);

    } catch (err) {
      setError(err.message);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-black flex flex-col justify-center items-center p-4">
      <div className="w-full max-w-md bg-gray-900/50 border border-yellow-500/20 rounded-xl p-8 shadow-2xl shadow-yellow-500/10">
        <div className="text-center mb-8">
          <h1 className="text-3xl font-bold text-yellow-400">{t.title}</h1>
          <p className="text-gray-400 mt-2">{t.subtitle}</p>
        </div>

        <form onSubmit={handleSubmit} noValidate>
          {message && <div className="bg-green-500/20 border-green-500 text-green-300 p-3 rounded-lg mb-4">{message}</div>}
          {error && <p className="text-red-500 text-sm text-center mb-4">{error}</p>}
          
          {!message && (
            <>
              <div className="mb-4">
                <label htmlFor="email" className="block text-gray-300 text-sm font-bold mb-2">{t.emailLabel}</label>
                <input id="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required className="w-full bg-gray-800 border-gray-700 rounded-lg p-2 text-white" />
              </div>
              <div className="mb-6">
                <button type="submit" disabled={isLoading} className="w-full bg-yellow-500 hover:bg-yellow-400 text-black font-bold py-3 px-4 rounded-lg disabled:bg-gray-600">
                  {isLoading ? t.sending : t.sendLink}
                </button>
              </div>
            </>
          )}

          <p className="text-center text-sm text-gray-500 mt-4">
            {t.rememberedPassword}{' '}
            <Link to={`/${lang}/login`} className="font-bold text-yellow-400 hover:text-yellow-300">
              {t.logIn}
            </Link>
          </p>
        </form>
      </div>
    </div>
  );
};

export default ForgotPasswordPage;